import Row from '@totallymoney/ui/components/Row'
import Text from '@totallymoney/ui/components/Text'

const AdvertisementBanner = () => {
    return (
        <Row space="space05">
            <Text variant="80" weight="bold">
                Advertisement
            </Text>
            <Text textAlign="center" variant="80">
                Your matches will continue below
            </Text>
        </Row>
    )
}

export default AdvertisementBanner
